import { Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import images from 'assets/images';
import React from 'react';

interface IDialogFormProps {
    openDialog?: boolean;
    handleDialogClose?: () => void;
    title?: string;
    className?: string;
    bodyContent?: React.ReactNode;
    hideCloseButton?: boolean;
}

const DialogForm: React.FC<IDialogFormProps> = ({
    openDialog,
    handleDialogClose,
    title,
    bodyContent,
    className,
    hideCloseButton = false,
}) => {
    return (
        <Dialog
            open={openDialog}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    handleDialogClose;
                }
            }}
            aria-labelledby="form-dialog-title"
            className={`custom-dialog ${className}`}
        >
            <DialogTitle id="form-dialog-title" className={hideCloseButton ? 'py-2' : ''}>
                {title}
                {!hideCloseButton && (
                    <IconButton onClick={handleDialogClose}>
                        <img src={images.closeDark} alt="Close" />
                    </IconButton>
                )}
            </DialogTitle>
            <DialogContent>{bodyContent}</DialogContent>
        </Dialog>
    );
};
export default DialogForm;
